import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Acne.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const acneFAQs = [
  {
    question: 'How long does acne treatment take to show results?',
    answer: 'Most people notice a visible reduction in breakouts within 4 to 6 weeks, though full results depend on the severity and type of acne.',
  },
  {
    question: 'Can acne scars be treated along with active acne?',
    answer: 'Active acne is usually brought under control first before starting scar treatment, since new breakouts can lead to new scarring.',
  },
  {
    question: 'Is acne treatment suitable for sensitive skin?',
    answer: 'Yes, treatment plans are customized based on your skin type, including gentler options for sensitive or reactive skin.',
  },
  {
    question: 'Will my acne come back after treatment?',
    answer:
      'With the right maintenance skincare and follow-up care, recurrence can be minimized, though hormonal or lifestyle factors may need ongoing management.',
  },
]

const Acne = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='acnehero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Acne
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Best Acne Treatment in Pitampura | Advanced Pimple and Acne Scar Treatment
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best acne treatment in Pitampura? get advanced solutions for pimples , acne scars , and oily skin with safe
                dermatology treatments for clear and healthy skin.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>

        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Acne Treatment in Pitampura</h2>
              <p>
                Acne is one of the most common skin concerns affecting teenagers and adults. Pimples, blackheads, whiteheads, and acne scars can
                appear due to excess oil production, clogged pores, hormonal changes, or bacterial infection. If acne is not treated properly, it can
                lead to long-term skin damage and permanent scarring.
              </p>
              <p>
                Choosing the <span style={{ fontWeight: 'bold' }}>best acne treatment in Pitampura</span> helps control breakouts, reduce
                inflammation, and restore clear, healthy skin. Modern dermatology treatments focus on addressing the root cause of acne while
                improving overall skin texture.
              </p>
              <p>Professional skin clinics use advanced techniques and personalized treatment plans to achieve long-lasting results.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>What Causes Acne?</h3>
              <p>
                Acne develops when hair follicles become clogged with oil and dead skin cells. Several factors may trigger or worsen acne, including:
              </p>
              <ul>
                <li>Excess oil production</li>
                <li>Hormonal imbalance</li>
                <li>Bacterial growth in pores</li>
                <li>Stress and lifestyle factors</li>
                <li>Use of unsuitable skincare products</li>
                <li>Genetic predisposition</li>
              </ul>
              <p>Dermatologists evaluate these factors before recommending the most suitable treatment.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Advanced Acne Treatments Available</h3>
              <p>Modern dermatology offers several effective procedures for treating acne and acne scars.</p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Chemical Peels</span>
                <br />
                Chemical peels remove the outer layer of damaged skin and help unclog pores, reduce acne marks, and improve skin clarity. Salicylic or
                glycolic acid peels are commonly used for acne-prone skin.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Microneedling</span>
                <br />
                Microneedling stimulates collagen production and helps repair acne scars by creating controlled micro-injuries in the skin that
                trigger natural healing.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Laser Treatment</span>
                <br />
                Advanced laser technology targets bacteria and inflammation while stimulating collagen production to reduce acne scars and
                pigmentation.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Carbon Facial</span>
                <br />
                Carbon laser facial deeply cleans pores, controls oil production, and helps reduce mild acne breakouts while improving overall skin
                texture.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Medical Treatment</span>
                <br />
                Dermatologists may also prescribe topical medications or treatments like benzoyl peroxide or hormonal therapy to control acne-causing
                bacteria and inflammation.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Professional Acne Treatment</h3>
              <p>
                Choosing the <span style={{ fontWeight: 'bold' }}>best acne treatment in Pitampura</span> offers several benefits:
              </p>
              <ul>
                <li>Reduces active pimples and breakouts</li>
                <li>Controls excess oil production</li>
                <li>Minimizes acne scars and marks</li>
                <li>Improves skin texture and tone</li>
                <li>Prevents future acne formation</li>
                <li>Restores clear and healthy skin</li>
              </ul>
              <p>These treatments are customized based on skin type and acne severity.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Who Should Consider Acne Treatment?</h3>
              <p>Professional acne treatment is recommended for individuals experiencing:</p>
              <ul>
                <li>Frequent acne breakouts</li>
                <li>Painful cystic acne</li>
                <li>Acne scars or dark spots</li>
                <li>Oily and acne-prone skin</li>
                <li>Acne that does not improve with home remedies</li>
              </ul>
              <p>Early treatment can prevent permanent scars and improve overall skin health.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Get the best acne treatment in Pitampura</h3>
              <p>
                If you are struggling with acne or acne scars, professional skin treatments can help restore smooth and healthy skin.The{' '}
                <span style={{ fontWeight: 'bold' }}>best acne treatment in Pitampura</span> combines medical expertise with advanced dermatology
                procedures to provide long-lasting results.
              </p>
              <p>Consult a qualified skin specialist to receive a personalized acne treatment plan designed for your skin type and concerns.</p>

              <ServiceDoctorInfo
                name='Dr. Sweta Mishra'
                specialty='Maxillofacial Aesthetic Surgeon'
                education='MDS, FAM, Dip. in Aesthetic Medicine'
                image={doc_img}
                blurb='Dr. Sweta Mishra creates customized acne treatment plans at Sharva Clinique, combining medical-grade skincare with in-clinic procedures for lasting results.'
                profileLink='/acne'
              />

              <ServiceFAQ title='FAQs - Acne Treatment' faqs={acneFAQs} />
            </div>
          </div>

          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>

            <div className='card1'>
              <p>“My acne scars used to bother me a lot. After a few sessions, my skin looks much smoother. The results are subtle but very real.”</p>
              <p> — Vikram </p>
            </div>

            <div className='card2'>
              <p>“The consultation was detailed and honest. They didn’t push unnecessary treatments. My breakouts are under control now.”</p>
              <p> — Kritika </p>
            </div>

            <div className='card3'>
              <p>
                “I had deep acne scars and thought nothing would work. The laser sessions really improved my skin texture. I’m very happy with the
                outcome.”
              </p>
              <p> — Manish</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Acne
